"use strict";
var htmlBody = document.querySelector(".js-body");
document.addEventListener("DOMContentLoaded", function () {
    common.init();
    htmlBody.classList.add("is-loaded");
    home.init();
});
window.addEventListener("load", function () {
    common.loaded();
});
window.addEventListener("scroll", function () {
});
window.addEventListener("touchmove", function () {
});
var common = {
    init: function () {
        userAgent.init(), btnScroll.init();
    },
    loaded: function () {
        var hash = location.hash;
        hash = hash.replace("#", "#_");
        if (hash) {
            var targetElement = document.querySelector(hash);
            if (targetElement !== null) {
                var targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }
    },
    scroll: function () {
        var target = document.getElementsByClassName("js-animeFadeIn");
        for (var i = 0; i < target.length; i++) {
            var offsetTop = Math.floor(target[i].getBoundingClientRect().top);
            if (offsetTop < win.h()) {
                target[i].classList.add("is-active");
            }
        }
    }
};
var userAgent = {
    init: function () {
        var ua = navigator.userAgent;
        var device;
        if ((ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) || (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0)) {
            device = "is-sp";
        }
        else {
            device = "is-pc";
        }
        htmlBody.classList.add(device);
    }
};
var win = {
    t: window,
    w: function () {
        return win.t.innerWidth;
    },
    h: function () {
        return win.t.innerHeight;
    },
    st: function () {
        return win.t.scrollY;
    }
};
var isUser = {
    type: function (className) {
        if (htmlBody.classList.contains(className)) {
            return true;
        }
        else {
            return false;
        }
    }
};
var btnScroll = {
    t: document.getElementsByClassName("js-scroll"),
    init: function () {
        var _loop_1 = function (i) {
            btnScroll.t[i].addEventListener("click", function (e) {
                e.preventDefault();
                //e.stopPropagation();
                var href = btnScroll.t[i].getAttribute("href");
                if (href) {
                    href = href.replace("#", "#_");
                    var targetElement = document.querySelector(href);
                    if (targetElement !== null) {
                        var targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
                        window.scrollTo({
                            top: targetOffsetTop,
                            behavior: "smooth"
                        });
                    }
                }
            }, false);
        };
        for (var i = 0; i < btnScroll.t.length; i++) {
            _loop_1(i);
        }
    }
};
var home = {
    init: function () {
        var blkModel02 = document.getElementById("blkModel02");
        var blkModel03 = document.getElementById("blkModel03");
        var model02_add = document.getElementById("model02_add");
        var model03_add = document.getElementById("model03_add");
        var modelRest = function () {
            if (model02_add && model02_add.checked) {
                blkModel02 !== null && blkModel02.classList.add('is-show');
            }
            if (model03_add && model03_add.checked) {
                blkModel03 !== null && blkModel03.classList.add('is-show');
            }
        };
        modelRest();
        var modelChange = function () {
            if (model02_add && model02_add.checked) {
                blkModel02 !== null && blkModel02.classList.add('is-show');
            }
            else {
                blkModel02 !== null && blkModel02.classList.remove('is-show');
            }
            if (model03_add && model03_add.checked) {
                blkModel03 !== null && blkModel03.classList.add('is-show');
            }
            else {
                blkModel03 !== null && blkModel03.classList.remove('is-show');
            }
        };
        model02_add.addEventListener('change', function () {
            modelChange();
        });
        model03_add.addEventListener('change', function () {
            modelChange();
        });
    }
};
